module.exports = __webpack_public_path__ + "img/SES_8030.8ee71242.jpg";